module.exports = __webpack_public_path__ + "static/media/ended-class-tips.a3f8ecba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ended-class-tips.png
// module id = 1975
// module chunks = 6